// @flow
import { Action } from './type'

export type PermissionAction = Action & {
  type:
    | 'REQUEST_PERMISSION'
    | 'SUCCESS_FETCH_PERMISSION'
    | 'FAIL_FETCH_PERMISSION'
}

export type Permission = 'moderator' | 'enterprise' | 'trial' | 'guest' | null

export const REQUEST_PERMISSION = 'REQUEST_PERMISSION'
export const requestPermission = () => ({ type: REQUEST_PERMISSION })

export const SUCCESS_FETCH_PERMISSION = 'SUCCESS_FETCH_PERMISSION'
export const successFetchPermission = (
  role: Permission,
  latestPlan: boolean,
  restricted: boolean,
  allowed: boolean,
  earlyAccess: boolean
) => ({
  type: SUCCESS_FETCH_PERMISSION,
  payload: { role, latestPlan, restricted, allowed, earlyAccess },
})

export const FAIL_FETCH_PERMISSION = 'FAIL_FETCH_PERMISSION'
export const failFetchPermission = (err: any) => ({
  type: FAIL_FETCH_PERMISSION,
  payload: err,
})
